module.exports = __webpack_public_path__ + "static/img/The High Priestess.81e0ce0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The High Priestess.jpg
// module id = 1316
// module chunks = 0